import React from 'react';
import { SlippageToleranceInputProps } from 'src/components/TradeForm/SlippageToleranceInput/types';
import useSlippageToleranceInput from 'src/components/TradeForm/SlippageToleranceInput/hooks/useSlippageToleranceInput';
import ControlledSlippageToleranceInput from 'src/components/TradeForm/SlippageToleranceInput/ControlledSlippageToleranceInput';

function SlippageToleranceInput({
	className,
	optionsClassName,
	hideCustom,
	hideDynamic,
	disabled,
	slippageTolerance: slippageToleranceFromProps,
	updateHandler,
	slippageValue: slippageValueFromProps,
}: SlippageToleranceInputProps) {
	const {
		isCurrentDynamic,
		handleCustomInputChange,
		handleBlur,
		handleFocus,
		handlePresetClick,
		customInputValue,
		isCustomInputFocused,
		currentValue,
		presetOptions,
	} = useSlippageToleranceInput({
		slippageToleranceFromProps,
		slippageValueFromProps,
		updateHandler,
		hideDynamic,
	});

	return (
		<ControlledSlippageToleranceInput
			className={className}
			optionsClassName={optionsClassName}
			handleCustomInputChange={handleCustomInputChange}
			handlePresetClick={handlePresetClick}
			presetOptions={presetOptions}
			customInputValue={customInputValue}
			isCustomInputFocused={isCustomInputFocused}
			handleBlur={handleBlur}
			handleFocus={handleFocus}
			currentValue={currentValue}
			isCurrentDynamic={isCurrentDynamic}
			hideCustom={hideCustom}
			hideDynamic={hideDynamic}
			disabled={disabled}
		/>
	);
}

export default React.memo(SlippageToleranceInput);
